import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fetchMeta } from "@/lib/api";
import { Reveal, SplitLines } from "@/components/Reveal";

const SPANS = ["lg:col-span-7 lg:row-span-2", "lg:col-span-5", "lg:col-span-5", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4"];

export const Spaces = () => {
  const { data: meta } = useQuery({ queryKey: ["meta"], queryFn: fetchMeta });
  const spaces = meta?.spaces || [];
  return (
    <section id="spaces" data-testid="spaces-section" className="bg-[var(--bg)] py-28 lg:py-36">
      <div className="container-x">
        <Reveal><p className="eyebrow mb-6">View Designs</p></Reveal>
        <SplitLines as="h2" inView className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.05] tracking-tight text-[var(--navy)] max-w-3xl" lines={["Tailored tile solutions —", <>perfect for <em className="italic text-[var(--mint)]">every space.</em></>]} />
        <div className="mt-14 grid gap-5 lg:grid-cols-12 lg:auto-rows-[260px]">
          {spaces.map((sp, i) => (
            <motion.div key={sp.slug} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-5% 0px" }} transition={{ duration: 0.8, delay: i * 0.08 }} className={`${SPANS[i]} min-h-[260px]`}>
              <Link to={`/collection?space=${sp.slug}`} data-testid={`space-card-${sp.slug}`} className="group relative block h-full overflow-hidden rounded-[1.5rem]">
                <img src={sp.image} alt={sp.label} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(.2,.8,.2,1)] group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b1526]/85 via-[#0b1526]/10 to-transparent" />
                <div className="absolute inset-x-6 bottom-6 flex items-end justify-between">
                  <div>
                    <div className="font-mono text-[0.58rem] uppercase tracking-[0.25em] text-[var(--mint-light)]">0{i + 1}</div>
                    <h3 className="font-display text-2xl font-medium text-white sm:text-3xl">{sp.label}</h3>
                  </div>
                  <span className="grid h-11 w-11 place-items-center rounded-full bg-white text-[var(--navy)] transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight size={18} /></span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
